import { useParams } from 'react-router-dom'
import { Stack } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { useQCTask } from '@features/qc_task_details_view/hooks/useQCTask'
import QCDetailsOverview from './QCDetailsOverview'

export default function QCOverview() {
  const { studyId, qcTaskId } = useParams()

  const { data: qcTaskData, error: qcTaskError, isLoading: isQcTaskLoading } = useQCTask(['QCTask'], studyId, qcTaskId)

  if (isQcTaskLoading) {
    return <div>Loading...</div>
  }

  if (qcTaskError || !qcTaskData || !qcTaskData.data) {
    return <div>Error: {qcTaskError?.message}</div>
  }

  return (
    <Stack spacing={SPACING.sectionsSpacing}>
      <QCDetailsOverview qcTask={qcTaskData.data} />
    </Stack>
  )
}
